export default {
  id: "plan-route",
  title: "Plan an optimised route",
  summary: "Let the Voyage Planner find a time- or fuel-optimised route",
  minutes: 5,
  interactive: [{ selector: ".leaflet-container" }],
  steps: [
    {
      title: "Plan an optimised route",
      text: "The Voyage Planner finds the best route for your vessel, taking the weather forecast into account. This tour takes you through one calculation.",
    },
    {
      anchor: "drawer-planner",
      skipIf: "planner-panel",
      click: true,
      title: "Open the Voyage Planner",
      text: "Click <b>Voyage Planner</b>.",
      side: "right",
    },
    {
      anchor: "planner-steps",
      skipIf: "planner-mode",
      until: "planner-mode",
      title: "Start at step 1",
      text: "Click <b>1 · Plan</b>.",
      side: "right",
    },
    {
      anchor: "planner-steps",
      title: "Three steps",
      text: "Planning works in three steps: <b>Plan</b> (where and when), <b>Options</b> (vessel data) and <b>Result</b>.",
      side: "right",
    },
    {
      anchor: "planner-mode",
      title: "Time or fuel?",
      text: "Choose what the route should be optimised for:<ul><li><b>Time</b>: earliest arrival.</li><li><b>Fuel</b>: lowest fuel cost. Needs a bunker price and a consumption profile.</li><li><b>Manual</b>: you set the waypoints yourself (see the tutorial <b>Create a manual route</b>).</li></ul>Select <b>Time</b> or <b>Fuel</b>.",
      side: "right",
    },
    {
      anchor: "planner-vessel",
      title: "Vessel and voyage",
      text: "Select the vessel. The planner shows whether the route is added to the vessel's current voyage or starts a new voyage.",
      side: "right",
    },
    {
      anchor: "planner-endpoints",
      title: "Departure and arrival",
      text: "Type a port name or a position as <b>lat, lon</b>.<ul><li>The vessel button next to <b>Departure</b> uses the vessel's latest position.</li><li>You can also click on the map: the first click sets the departure, the second the arrival.</li></ul>",
      side: "right",
    },
    {
      anchor: "planner-departure",
      title: "Departure time and speed",
      text: "Set the departure time (UTC) and the <b>base speed</b>, i.e. the speed in calm weather.",
      side: "right",
    },
    {
      anchor: "planner-restrictions",
      title: "Routing restrictions",
      text: "Choose what the route should avoid: heavy weather (<b>RNW Safety</b>), emission control areas (<b>ECA</b>) and risk zones such as piracy or war risk areas.",
      side: "right",
    },
    {
      anchor: "planner-footer",
      click: "planner-primary",
      title: "Continue",
      text: "Click <b>Continue to Options</b>. If the button is grey, the red hint above it tells you what is missing. You can still change everything in the planner.",
      side: "top",
    },
    {
      anchor: "planner-options",
      title: "Options",
      text: "Check the vessel data used for the calculation:<ul><li><b>Vessel</b>: vessel specifications.</li><li><b>Voyage</b>: weather limits, bunker prices, safety depth and air draft.</li><li><b>Speed Profile</b> / <b>Consumption</b>: how weather affects speed and fuel use.</li></ul>",
      side: "right",
    },
    {
      anchor: "planner-footer",
      click: "planner-primary",
      title: "Find the route",
      text: "Click <b>Find Route</b> to start the calculation. If the button is grey, go back to <b>1 · Plan</b> and add what the red hint asks for.",
      side: "top",
    },
    {
      anchor: "planner-panel",
      until: "planner-result",
      title: "Calculating …",
      text: "The route is being calculated. This can take up to a few minutes. The tour continues automatically when the result is ready.<br><br>If the calculation fails, the panel explains why. Click <b>Adjust inputs</b>, fix it and press <b>Find Route</b> again. The tour waits for you.",
      side: "right",
    },
    {
      anchor: "planner-result",
      title: "The result",
      text: "Here you see ETA, duration, distance, consumption, fuel cost and the highest wave and wind along the route. Coloured labels show warnings, e.g. heavy weather or risk zones.",
      side: "right",
    },
    {
      selector: ".leaflet-container",
      title: "Route on the map",
      text: "The new route is drawn on the map in <b>yellow</b>. Move the time slider to see where the vessel will be and what weather it meets.",
      side: "over",
    },
    {
      anchor: "planner-primary",
      title: "Save or compare",
      text: "The result is a <b>draft</b> and is not saved yet. Click <b>Show in Fleet Explorer</b> to find it there. Save it with the <b>⋮</b> menu, or compare it with the active route (tutorial <b>Compare routes & set active</b>).",
      side: "top",
    },
  ],
}
